import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import { useMount } from 'react-use';
import { getAllQueues } from 'components/settings/actions/queues';
import MessagingList from 'components/settings/containers/sections/messaging/messagingList';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { SettingsMessagingView } from './settingsMessaging.view';
import { SettingsMessagingFacebookSetupView } from './views/facebookSetup';
import { SettingsMessagingWhatsAppSetupView } from './views/whatsAppSetup';
const SettingsMessagingRoutes = () => {
    const dispatch = useAppDispatch();
    const { messagingSettingsRedesign } = useFeatureFlag([
        'messaging-settings-redesign',
    ]);
    useMount(() => {
        dispatch(getAllQueues());
    });
    return (_jsxs(Routes, { children: [_jsx(Route, { index: true, element: messagingSettingsRedesign ? (_jsx(SettingsMessagingView, {})) : (_jsx(MessagingList, {})) }), _jsx(Route, { path: "facebook/setup", element: _jsx(SettingsMessagingFacebookSetupView, {}) }), _jsx(Route, { path: "facebook/:appId/add-page", element: _jsx(SettingsMessagingFacebookSetupView, {}) }), _jsx(Route, { path: "whatsapp/setup", element: _jsx(SettingsMessagingWhatsAppSetupView, {}) })] }));
};
/** The messaging settings routes of the application. */
export const settingsMessagingRoutes = (_jsx(Route, { path: "messaging/*", element: _jsx(SettingsMessagingRoutes, {}) }));
